import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const productCarouselDefaultBlocks: BlockNode[] = [
  {
    id: 'product-carousel-heading',
    type: 'text',
    content: { type: 'text', value: 'Featured Products', fontSize: 28, fontWeight: 700, textAlign: 'left' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'product-carousel-subheading',
    type: 'text',
    content: { type: 'text', value: 'Hand-picked for you', fontSize: 16, fontWeight: 400, textAlign: 'left' },
    layout: { order: 1, widthPct: 100 },
  },
];

export const productCarouselWidget = defineWidget({
  type: 'product-carousel',
  schema: {
    label: 'Product Carousel',
    description: 'Horizontal scrolling strip of product cards',
    props: {
      limit: {
        type: 'number',
        label: 'Number of products',
        min: 1,
        max: 50,
        default: 8,
        structural: true,
      },
      showHeaderLink: {
        type: 'boolean',
        label: 'Show Header Link',
        default: false,
      },
      headerLinkIcon: {
        type: 'icon',
        label: 'Header Link Icon',
        default: 'chevron-right',
      },
      headerLinkUrl: {
        type: 'link',
        label: 'Header Link URL',
      },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
      subheading: { type: 'text', label: 'Section Subheading' },
      headerLinkText: { type: 'text', label: 'Header Link Text' },
    },
    dataDeps: ['featuredProducts'],
  },
  nameTh: 'สินค้าแบบเลื่อน',
  descriptionTh: 'แถบสินค้าเลื่อนซ้ายขวาได้',
  category: 'products',
  thumbnail: '/widget-thumbnails/product-carousel.svg',
  defaults: {
    type: 'product-carousel',
    props: { limit: 8 },
    slots: {
      heading: { value: 'Featured Products' },
    },
  },
  defaultBlocks: productCarouselDefaultBlocks,
});
